import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVetV1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 411,
	height: 359,
	viewBox: "0 0 411 359",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_718_1197)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M209.19 358.3C298.936 358.3 371.69 285.546 371.69 195.8C371.69 106.054 298.936 33.3 209.19 33.3C119.444 33.3 46.6899 106.054 46.6899 195.8C46.6899 285.546 119.444 358.3 209.19 358.3Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M314.42 303.5H249.99C249.16 303.5 248.49 302.83 248.49 302C248.49 301.17 249.16 300.5 249.99 300.5H314.42C315.25 300.5 315.92 301.17 315.92 302C315.92 302.83 315.25 303.5 314.42 303.5Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M349.65 303.5H323.89C323.06 303.5 322.39 302.83 322.39 302C322.39 301.17 323.06 300.5 323.89 300.5H349.65C350.48 300.5 351.15 301.17 351.15 302C351.15 302.83 350.48 303.5 349.65 303.5Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M241.96 303.5H60.73C59.9 303.5 59.23 302.83 59.23 302C59.23 301.17 59.9 300.5 60.73 300.5H241.97C242.8 300.5 243.47 301.17 243.47 302C243.47 302.83 242.8 303.5 241.97 303.5H241.96Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.3601C87.7401 290.69 82.3501 285.3 82.3501 278.68V62.46C82.3501 55.84 87.7401 50.45 94.3601 50.45H260.34",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.36C87.74 290.69 82.35 285.3 82.35 278.68V62.46C82.35 55.84 87.74 50.45 94.36 50.45H260.34M260.33 37.63H94.35C80.64 37.63 69.52 48.75 69.52 62.46V278.68C69.52 292.39 80.64 303.51 94.35 303.51H260.33C274.04 303.51 285.16 292.39 285.16 278.68V62.46C285.16 48.75 274.04 37.63 260.33 37.63Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 0.309998C187.69 0.309998 196.31 8.93 196.31 19.55V30.24H157.83V19.55C157.83 8.93 166.45 0.309998 177.07 0.309998Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 24.5C180.958 24.5 184.11 21.3481 184.11 17.46C184.11 13.5719 180.958 10.42 177.07 10.42C173.182 10.42 170.03 13.5719 170.03 17.46C170.03 21.3481 173.182 24.5 177.07 24.5Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_718_1197",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 119,
				y: 25,
				width: 116,
				height: 40,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_718_1197)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M241.63 55.98H112.51V68.12H241.63V55.98Z",
					fill: "#FFB100"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M335.95 139.12C335.97 139.62 335.78 140.12 335.43 140.47L322.82 153.09C322.5 153.41 322.09 153.63 321.65 153.67C321.11 153.71 320.6 153.53 320.23 153.15L314.8 147.72C314.44 147.36 314.25 146.87 314.28 146.37C314.3 145.87 314.54 145.39 314.93 145.07C315.63 144.49 316.71 144.56 317.38 145.23L321.47 149.32C321.47 149.32 321.52 149.34 321.53 149.32L332.87 137.98C333.54 137.31 334.61 137.24 335.32 137.82C335.71 138.14 335.94 138.62 335.97 139.12H335.95Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 125.66C139.845 125.66 147.68 117.825 147.68 108.16C147.68 98.495 139.845 90.66 130.18 90.66C120.515 90.66 112.68 98.495 112.68 108.16C112.68 117.825 120.515 125.66 130.18 125.66Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 100.46H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 116.94H228.01",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 191.1C139.845 191.1 147.68 183.265 147.68 173.6C147.68 163.935 139.845 156.1 130.18 156.1C120.515 156.1 112.68 163.935 112.68 173.6C112.68 183.265 120.515 191.1 130.18 191.1Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 165.89H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 182.38H210.64",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 256.54C139.845 256.54 147.68 248.705 147.68 239.04C147.68 229.375 139.845 221.54 130.18 221.54C120.515 221.54 112.68 229.375 112.68 239.04C112.68 248.705 120.515 256.54 130.18 256.54Z",
				fill: "#3F8BFD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 231.33H192.76",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 247.82H228.01",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 109.32L128.38 113.68L137.55 104.51",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 174.3L128.38 178.65L137.55 169.48",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 240.23L128.38 244.58L137.55 235.41",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("g", {
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M217.68 166.08H253.69C254.17 166.08 254.57 165.7 254.57 165.22C254.57 164.74 254.18 164.36 253.69 164.36H217.68V166.08Z",
					fill: "#152A61"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M254.21 116.9C257.25 115.34 260.71 114.46 264.38 114.46H269.71C271.87 114.46 273.99 114.69 276.01 115.13L266.46 98.62C266.03 97.88 264.95 97.89 264.53 98.62L254.2 116.89L254.21 116.9Z",
				fill: "#3F8BFD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M210.49 153.7V166.76C210.49 172.63 215.34 177.39 221.33 177.39H242C244.8 177.39 247.06 179.63 247.06 182.36V282.2H243.26C234.8 282.2 227.93 288.95 227.93 297.27V303.48H382.26C385.27 303.48 387.73 301.07 387.73 298.09C387.73 296.61 387.12 295.25 386.12 294.29C385.14 293.31 383.77 292.71 382.27 292.71H376.79V248.26C376.79 219.38 352.97 195.96 323.57 195.96H304.2C301.4 195.96 299.14 193.74 299.14 190.99V143.31C299.14 140.38 298.68 137.56 297.86 134.88L294.71 128.07L281.2 98.89C280.81 98.08 279.66 98.05 279.22 98.82L270.37 114.46C270.16 114.44 269.93 114.44 269.72 114.44H264.39C252.18 114.44 242.28 124.16 242.28 136.14V139.72C242.28 143.01 239.58 145.67 236.24 145.67H218.65C214.15 145.67 210.49 149.27 210.49 153.69V153.7Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M210.49 155.65V166.77C210.49 172.64 215.34 177.4 221.33 177.4H242C242.89 177.4 243.72 177.62 244.45 178.02V169.38C244.45 161.79 238.18 155.65 230.45 155.65H210.48H210.49Z",
				fill: "#CEE2FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M220.15 165.22V184.11C220.15 187.67 223.09 190.56 226.71 190.56C230.34 190.56 233.27 187.67 233.27 184.11V165.22H220.14H220.15Z",
				fill: "#FFCAC5"
			}),
			/* @__PURE__ */ _jsx("g", {
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M226.72 182.38C227.2 182.38 227.6 182 227.6 181.52V165.21C227.6 164.73 227.21 164.35 226.72 164.35C226.23 164.35 225.84 164.74 225.84 165.21V181.52C225.84 182 226.23 182.38 226.72 182.38Z",
					fill: "#FFCAC5"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M210.49 153.7V155.65H214.87C218.03 155.65 220.62 153.11 220.62 150V145.69H218.65C214.15 145.69 210.49 149.28 210.49 153.71V153.7Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M255.7 137.21C255.7 139.32 253.96 141.02 251.82 141.02C249.68 141.02 247.94 139.31 247.94 137.21C247.94 135.11 249.68 133.4 251.82 133.4C253.96 133.4 255.7 135.11 255.7 137.21Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M250.58 139.32C251.784 139.32 252.76 138.357 252.76 137.17C252.76 135.983 251.784 135.02 250.58 135.02C249.376 135.02 248.4 135.983 248.4 137.17C248.4 138.357 249.376 139.32 250.58 139.32Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M210.49 166.08H246.5C246.98 166.08 247.38 165.7 247.38 165.22C247.38 164.74 246.99 164.36 246.5 164.36H210.49V166.08Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M227.94 297.29V303.5H272.07V259.77C272.07 257.12 269.88 254.97 267.18 254.97H247.07V282.22H243.27C234.81 282.22 227.95 288.97 227.95 297.3L227.94 297.29Z",
				fill: "#CEE2FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M235.65 303.5V299.35C235.65 295.01 239.24 291.48 243.66 291.48H246.33C247.01 291.48 247.55 290.94 247.55 290.28C247.55 289.62 247 289.08 246.33 289.08H243.66C237.9 289.08 233.21 293.69 233.21 299.35V303.5H235.66H235.65Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M284.02 299.15V303.49H344.61V286.77C344.61 284.12 342.42 281.97 339.72 281.97H306.74C294.17 281.97 284.01 289.66 284.01 299.16L284.02 299.15Z",
				fill: "#CEE2FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M292.91 303.5V299.35C292.91 295.01 296.5 291.48 300.92 291.48H303.59C304.27 291.48 304.81 290.94 304.81 290.28C304.81 289.62 304.26 289.08 303.59 289.08H300.92C295.16 289.08 290.47 293.69 290.47 299.35V303.5H292.92H292.91Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.6899 169.29C21.7099 169.79 21.5199 170.29 21.1699 170.64L8.55993 183.26C8.23993 183.58 7.82993 183.8 7.38993 183.84C6.84993 183.88 6.33993 183.7 5.96993 183.32L0.53993 177.89C0.17993 177.53 -0.0100701 177.04 0.0199299 176.54C0.0399299 176.04 0.27993 175.56 0.66993 175.24C1.36993 174.66 2.44993 174.73 3.11993 175.4L7.20993 179.49C7.20993 179.49 7.25993 179.51 7.26993 179.49L18.6099 168.15C19.2799 167.48 20.3499 167.41 21.0599 167.99C21.4499 168.31 21.6799 168.79 21.7099 169.29H21.6899Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M278.97 1.7C278.99 2.2 278.8 2.7 278.45 3.05L265.84 15.67C265.52 15.99 265.11 16.21 264.67 16.25C264.13 16.29 263.62 16.11 263.25 15.73L257.82 10.3C257.46 9.94 257.27 9.45 257.3 8.95C257.32 8.45 257.56 7.97 257.95 7.65C258.65 7.07 259.73 7.14 260.4 7.81L264.49 11.9C264.49 11.9 264.54 11.92 264.55 11.9L275.89 0.559999C276.56 -0.110001 277.63 -0.180001 278.34 0.399999C278.73 0.719999 278.96 1.2 278.99 1.7H278.97Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M410.35 95.27C410.39 96.04 410.09 96.8 409.55 97.35L390.17 116.73C389.68 117.22 389.05 117.56 388.37 117.62C387.55 117.69 386.76 117.4 386.19 116.82L377.84 108.47C377.29 107.92 377 107.16 377.04 106.39C377.08 105.62 377.44 104.89 378.04 104.4C379.12 103.51 380.77 103.61 381.8 104.64L388.09 110.93C388.09 110.93 388.16 110.96 388.19 110.93L405.61 93.51C406.64 92.48 408.28 92.38 409.37 93.27C409.97 93.77 410.33 94.49 410.37 95.27H410.35Z",
				fill: "#DCEBFE"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_718_1197",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 410.36,
			height: 358.3,
			fill: "white"
		})
	}) })]
});
export default SvgVetV1;
